module.exports = __webpack_public_path__ + "static/media/FolderOpened.6ff56797.svg";